<template>

  <div v-if="approvals">
    <ApprovalList
      @hideModal="hide()" 
      @deleted="hide()" />
  </div>
  
</template>

<script>
import ApprovalList from './ApprovalList'

export default {
  name: 'ApprovalObserver',
  components: {
    ApprovalList
  },
  data () {
    return {
    }
  },
  computed: {
    approvals () {
      return this.$route.query.approvals
    }
  },
  created () {
  },
  methods: {
    hide () {
      this.$changeUrlParam({
        approvals: undefined,
        approvals_type: undefined
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Approval/ApprovalObserver.vue